<template>
  <div v-loading="loading">
    <div class="h-full flex items-center">
      <el-dropdown>
        <button class="sort-button flex items-center justify-center rounded-md h-full mr-3"
          style="width: 40px; height: 40px; background-color: #f7fafd">
          <sort-icon />
        </button>
        <el-dropdown-menu slot="dropdown" placement="right-end">
          <el-dropdown-item disabled>SORT BY</el-dropdown-item>

          <el-dropdown-item>
            <button @click="sortOrder = 'ASC'" class="flex items-center">
              <span class="ml-2">ASC</span>
            </button>
          </el-dropdown-item>
          <el-dropdown-item>
            <button @click="sortOrder = 'DESC'" class="flex items-center">
              <span class="ml-2">DESC</span>
            </button>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <div class="flex items-center mr-12">
        <el-select v-model="selectedServiceRoute" placeholder="Select service route" style="margin: 0">
          <el-option label="all" :value="null" />
          <el-option v-for="shippingservice in locationBasedRoutes" :key="shippingservice.id"
            :label="shippingservice.routeName" :value="shippingservice.id">
          </el-option>
        </el-select>
      </div>

      <div hidden class="date-picker flex items-center justify-center">
        <el-date-picker type="date" placeholder="Start Date" style="margin: 0" class="mr-3" v-model="startDate" />

        <el-date-picker type="date" placeholder="End Date" style="margin: 0" v-model="endDate" />
      </div>
    </div>

    <div class="table-wrapper" id="table-wrapper">
      <table class="custom-table responsive-table">
        <thead>
          <tr>
            <th class="width-xs">
              <input class="checkbox" type="checkbox" @change="changedAllValue($event)"
                v-model="shouldSelectAllBookings" />
            </th>
            <th class="shipping-ref-col width-sm">Consolidation ID + Date</th>
            <th>Fleet + Driver</th>
            <th class="text-center">Fleet Capacity</th>
            <th>Shipment Count</th>
            <th>Origin</th>
            <th>Destination</th>
            <th>Status</th>
            <th class="relative width-xs" tabindex="-1" @blur="isTableFilter = false">
              <span class="cursor-pointer" @click="isTableFilter = !isTableFilter">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <g opacity="0.7">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                      fill="#383F51" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                      fill="#383F51" />
                  </g>
                </svg></span>

            </th>
          </tr>
        </thead>
        <!-- <tbody v-if="unassignedBookings && unassignedBookings.length && !isFetchingBookings"> -->
        <tbody>
          <tr v-for="(booking) in longHaulDispatchables" :key="booking.id" class="cursor-pointer">
            <td>
              <input class="checkbox" type="checkbox" @change="changedValue($event, booking)"
                :checked="value_(booking)" />
            </td>

            <td>
              <span>{{
                booking ? booking.reference : "N/A"
                }}</span><span>MuleEx</span>
            </td>

            <td>
              <span>{{ booking?.fleet?.vehicletype || "N/A" }} - {{ booking?.fleet?.vehicleNumber || "N/A"
                }}</span><br />
              <span>{{ booking?.fleet?.driver?.firstname || "N/A" }} {{ booking?.fleet?.driver?.lastname || "N/A"
                }}</span>
            </td>

            <td>
              {{ booking?.fleet?.capacity || "N/A" }}
            </td>

            <td class="text-center">
              {{ booking ? booking.totalShipment : "N/A" }}

            </td>

            <td>
              {{ booking?.origin?.state || "N/A" }}

            </td>

            <td>
              {{ booking?.destination?.state || "N/A" }}
            </td>

            <td>
              <!-- Special case for Status -->
              <span>
                <button :title="booking?.orderStatus.replace(/_/g, ' ')" :class="['order_status']"
                  :style="{ ...statusColors(booking?.orderStatus) }">
                  {{ booking?.orderStatus.replace(/_/g, ' ').toLowerCase() }}</button>
              </span>
            </td>

            <td class="cursor-pointer relative" tabindex="-1">
              <el-dropdown>
                <button>
                  <vertical-ellipsis />
                </button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item disabled>ACTIONS</el-dropdown-item>

                  <el-dropdown-item>
                    <button class="flex items-center" @click="
                      showUpdateStatusModal = true;
                    selectedConsolidation = booking;
                    ">
                      <svg width="14" height="16" viewBox="0 0 14 16" fill="none">
                        <path
                          d="M11.9415 3.04297L10.5315 4.45897C11.4765 5.40447 12 6.66197 12 7.99997C12 10.758 9.758 13 7 13V12L5 14L7 16V15C10.8595 15 14 11.8595 14 7.99997C14 6.12697 13.2695 4.36697 11.9415 3.04297Z"
                          fill="#10233E" />
                        <path
                          d="M9 2L7 0V1C3.1405 1 0 4.1405 0 8C0 9.873 0.7305 11.633 2.0585 12.957L3.4685 11.541C2.5235 10.5955 2 9.338 2 8C2 5.242 4.242 3 7 3V4L9 2Z"
                          fill="#10233E" />
                      </svg>
                      <span class="ml-2">Update Status</span>
                    </button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <button class="flex items-center" @click="
                      showCancelModal = true;
                    selectedBooking = booking;
                    ">
                      <cancel-icon />
                      <span class="ml-2">Cancel</span>
                    </button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <button class="flex items-center" @click="routeBookingSumary(booking)">
                      <package-icon />
                      <span class="ml-2">Print</span>
                    </button>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="next-submit flex justify-end mt-4">
      <base-button text="Next" @click="proceed" :disabled="!isFormValid" />
    </div>

    <UpdateStatusModal :consolidation="selectedConsolidation" :showmodal="showUpdateStatusModal"
      @close-modal="showUpdateStatusModal = false" @refetch-consolidation="refetch" />

  </div>
</template>

<script>
import UpdateStatusModal from "../../../Consolidation/Modals/UpdateStatusModal.vue"

export default {
  props: {
    openShippingLabelAction: {}
  },
  components: {
    UpdateStatusModal
  },
  data() {
    return {
      showUpdateStatusModal: false,
      showShippingLabelModal: false,
      checkedDispatchable: [],
      type: 'long_haul',
      longHaulDispatchables: [],
      selectedShipment: [],
      checkedDispatchableDetail: [],
      shouldSelectAllBookings: false,
      selectedServiceRoute: "",
      locationBasedRoutes: [],
      endDate: null,
      startDate: null,
      selectedConsolidation: {},
      loading: false

    };
  },

  mounted() {
    this.getDispatchables({ type: this.type });
  },

  watch: {
    locationId(){
       this.getDispatchables({ type: this.type });
    }
  },

  computed: {
      locationId() {
      return this.$store.getters.currentLocationId;
    },
    buttonClass() {
      return this.isFormValid
        ? 'opacity-100 cursor-pointer hover:scale-105'
        : 'opacity-50 cursor-not-allowed';
    },



    isFormValid() {
      return (
        this.checkedDispatchable.length > 0 && this.canProceed()
      );
    }
  },

  methods: {
    statusColors(status) {
      const opac = "25";
      switch (status) {
        case "pending_loading":
          return { color: "#FFA600", backgroundColor: "#FFA60030" };
        case "loading":
          return { color: "#09B78A", backgroundColor: "#09B78A" + opac };
        case "loading_complete":
          return { color: "#09B78A", backgroundColor: "#09B78A" + opac };
        case "dispatched_for_delivery":
          return { color: "#09B78A", backgroundColor: "#09B78A" + opac };
        case "on-hold":
          return { color: "#FFA600", backgroundColor: "#FFA60015" };
        case "ready_for_dispatch":
          return { color: "#000000", backgroundColor: "#000000" + opac };
      }
    },
    refetch() {
      this.getDispatchables({ type: this.type })
    },
    value_(booking) {
      return this.checkedDispatchable.includes(booking.id)
    },

    hasSameDriver() {
      if (this.checkedDispatchableDetail.length <= 1) {
        return true;
      }

      const firstDriver =
        `${this.checkedDispatchableDetail[0]?.fleet?.driver?.firstname || ""} ${this.checkedDispatchableDetail[0]?.fleet?.driver?.lastname || ""
        }`;

      return this.checkedDispatchableDetail.every(item => {
        const driver =
          `${item?.fleet?.driver?.firstname || ""} ${item?.fleet?.driver?.lastname || ""
          }`;

        return driver === firstDriver;
      });
    },

    changedValue(checked, dispatch) {
      if (checked?.target?.checked) {
        this.checkedDispatchable.push(dispatch.id);
        this.checkedDispatchableDetail.push(dispatch);

        // Validate drivers
        if (!this.hasSameDriver()) {
          this.checkedDispatchable =
            this.checkedDispatchable.filter(id => id !== dispatch.id);

          this.checkedDispatchableDetail =
            this.checkedDispatchableDetail.filter(
              item => item.id !== dispatch.id
            );

          this.generateToast(
            "Only dispatches assigned to the same driver can be selected.",
            "error"
          );

          checked.target.checked = false;
          return;
        }
      } else {
        this.checkedDispatchable =
          this.checkedDispatchable.filter(
            item => item !== dispatch.id
          );

        this.checkedDispatchableDetail =
          this.checkedDispatchableDetail.filter(
            item => item.id !== dispatch.id
          );
      }

      if (!this.canProceed()) {
        this.generateToast(
          "All Dispatch must be of status Ready for Dispatch to proceed",
          "error"
        );
      }
    },


    changedAllValue(e) {
      let setShipment = [];
      let setDetailShipment = [];

      if (e?.target?.checked) {
        const firstDriver =
          `${this.longHaulDispatchables[0]?.fleet?.driver?.firstname || ""} ${this.longHaulDispatchables[0]?.fleet?.driver?.lastname || ""
          }`;

        const sameDriver = this.longHaulDispatchables.every(item => {
          const driver =
            `${item?.fleet?.driver?.firstname || ""} ${item?.fleet?.driver?.lastname || ""
            }`;

          return driver === firstDriver;
        });

        if (!sameDriver) {
          e.target.checked = false;

          this.generateToast(
            "Cannot select all. Dispatches belong to different drivers.",
            "error"
          );

          return;
        }

        this.longHaulDispatchables.forEach(element => {
          setShipment.push(element.id);
          setDetailShipment.push(element);
        });
      }

      this.checkedDispatchable = setShipment;
      this.checkedDispatchableDetail = setDetailShipment;

      if (!this.canProceed()) {
        this.generateToast(
          "All Dispatch must be of status Ready for Dispatch to proceed",
          "error"
        );
      }
    },

    canProceed() {
      return this.checkedDispatchableDetail.every(
        item => item.orderStatus === 'ready_for_dispatch'
      );
    },
 
    proceed() {
      if (this.isFormValid) {
        this.openShippingLabelAction()
        this.$emit('setSelecetedDIspatch', this.checkedDispatchable, this.type)
        this.$emit('setSelecetedDetailDispatch', this.checkedDispatchableDetail)

      } else {
        this.generateToast("Form is invalid, cannot proceed.", "error");
        return;
      }
    },

    async getDispatchables(params) {
      try {
        this.loading = true;

        const response = await this.$_getDispatchTable(
          this.locationId,
          params
        );
        this.longHaulDispatchables = response.data.data.data
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false
      }
    }

  }
}
</script>

<style scoped>
.order_status {
  @apply text-xs w-[130px] whitespace-nowrap capitalize text-ellipsis overflow-hidden rounded-2xl py-1.5 px-3 font-[500]
}
.next-submit>button {
  background-color: #FCC210;
  border-radius: 2px;
}

.driver_details {
  @apply py-1 px-2 bg-primary-blue/5 w-full text-center
}

.image_list {
  @apply flex items-center justify-between w-full border border-gray-400/40 bg-primary-blue/5 px-2 py-2 mt-2
}

.places_wrapper {
  @apply w-full lg:w-[48%]
}

#table-wrapper {
  margin: 2rem 0 0;
  overflow-x: auto;
}

.table-wrapper,
.table-wrapper .custom-table {
  transform: rotateX(180deg);
  -ms-transform: rotateX(180deg);
  -webkit-transform: rotateX(180deg);
}

/* width */
.table-wrapper::-webkit-scrollbar {
  cursor: pointer;
  width: 5px;
  height: 8px;
}

/* Track */
.table-wrapper::-webkit-scrollbar-track {
  background: #c4c4c4;
}

/* Handle */
.table-wrapper::-webkit-scrollbar-thumb {
  background: #fab427;
  width: 5px;
  border-radius: 20px;
}

.custom-table {
  margin: 0;
}

.booking-categories {
  display: flex;
}

.booking-category {
  color: #383f51;
  opacity: 0.7;
  display: flex;
  align-items: center;
  margin-right: 1rem;

  &.active {
    font-weight: 500;
    opacity: 1;

    .booking-category-amount {
      background: #10233e;
    }
  }

  .booking-category-amount {
    background: #8a97a5;
    border-radius: 10px;
    color: #ffffff;
    margin-left: 1rem;
    padding: 0.25rem 0.75rem;
  }
}

.table-header {
  justify-content: space-between;
}

.booking-categories {
  display: flex;
  align-items: center;
  margin: 2rem 0 4rem 0;
}

th {
  color: rgba(25, 48, 77, 0.7);
  font-weight: 500;
}

.checkbox {
  display: initial;
  width: 1rem;
  height: 1rem;
}

th {
  padding: 0.75rem;
  min-width: 10rem;
}

.width-md {
  min-width: 5rem;
}

.width-sm {
  min-width: 8rem;
}

.width-xs {
  min-width: 3rem !important;
}

td {
  background: #ffffff;
  color: var(--primaryblue);
  font-weight: 500;
  border-radius: 2px;
  padding: 0.75rem;
  vertical-align: top;

  span {
    display: block;
  }

  span:last-of-type {
    font-weight: normal;
    color: #10233e;
    opacity: 0.6;
    padding-top: 0.25rem;
    font-size: 0.8rem;
  }
}

.shipping-option-col {
  width: 16%;
}

.shipping-ref-col {
  width: 13%;
}

.booking-status {
  border-radius: 8px;
  padding: 0.5rem;
  font-weight: 500 !important;
  opacity: 1 !important;

  &.cancelled {
    background: #fae5e7;
    color: #d72638 !important;
  }

  &.pending {
    background: #ebfffa;
    color: #09b78a;
  }
}

table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}

.table__search-input-wrapper {
  background: #f7fafd;
  width: 20rem;
  border-radius: 5px;
}

.financial-summary {
  background: #ffffff;
  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 5px;

  .header {
    padding: 0.5rem 2rem;
  }

  width: 25rem;
}

.total-income {
  padding: 1rem 2rem;
}

.gross-income {
  background: var(--primaryblue);
  color: #ffffff;
  padding: 1rem 2rem;
}

.filter {
  background: #f7fafd;
  border-radius: 5px;
  padding: 0.75rem 1rem;
}

.card {
  padding: 2rem 2rem;
}

.input {
  margin-bottom: 1.5rem;
}

.label {
  color: #383f51;
  font-size: 0.9rem;
  font-weight: 600;
}

.actions {
  position: absolute;
  background: #ffffff;
  top: 0;
  right: 2rem;
  padding: 0.75rem;
  z-index: 9999;
  font-size: 0.9rem;
  width: 15rem;
  background: #ffffff;
  /* Stroke */
  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 10px;

  span {
    padding-right: 0.25rem;
  }

  >div {
    display: flex;
    align-items: center;
    padding-bottom: 0.5rem;
  }
}

.table__search-input-wrapper {
  background: #f7fafd;
  width: 20rem;
  border-radius: 5px;
  border: 1px solid #dae8f6;
  border-radius: 5px;
  height: 40px;
}

.table-sort {
  background: #f7fafd;
  /* Cards/Shadow-Small */
  box-shadow: 0px 1px 2px rgba(45, 49, 66, 0.06), 0px 1px 3px rgba(8, 7, 8, 0.1);
  border-radius: 5px;
}

.table-date-filter {
  width: 207px;
  background: #fbfcfe;
  border: 1px solid #dae8f6;
  border-radius: 4px;
}

.checkbox {
  width: 1.4rem;
  height: 1.4rem;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  background-color: #e5e7eb;
  /* gray */
  border: none;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
}

.checkbox:checked {
  background-color: #facc15;
  /* your yellow */
}

.checkbox:checked::after {
  content: "";
  margin-top: -2px;
  width: 0.35rem;
  height: 0.7rem;

  border: solid white;
  border-width: 0 2px 2px 0;

  transform: rotate(45deg);
  display: block;
}
</style>
